module.exports = __webpack_public_path__ + "static/media/team-canvas.3473a319.png";